import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { PROJECT_ID_STORAGE_KEY, isValidProjectId } from "./capture"

export interface ReferralState {
  projectId: string | null
}

const readStoredProjectId = (): string | null => {
  try {
    const stored = window.sessionStorage.getItem(PROJECT_ID_STORAGE_KEY)
    return isValidProjectId(stored) ? stored : null
  } catch {
    return null
  }
}

const initialReferralState: ReferralState = {
  projectId: readStoredProjectId(),
}

export const referralSlice = createSlice({
  name: "referral",
  initialState: initialReferralState,
  reducers: {
    setProjectId: (state, action: PayloadAction<string | null>) => {
      state.projectId = action.payload
    },
  },
})

export const { setProjectId } = referralSlice.actions
